import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { cookiesStorage } from "shared/helpers/cookiesStorage";
import { useAuth } from "shared/hooks";

function RequireAuth({ children }: any) {
  const { verified } = useAuth();
  let location = useLocation();
  const [verifySession, setVerifySession] = useState(
    cookiesStorage.get("IS_VERIFIED") ?? false
  );

  useEffect(() => {
    if (verified) {
      setVerifySession(verified);
    }
  }, [verified]);

  if (!verifySession) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <div>{children}</div>;
}

export default RequireAuth;
